import { EMigrateActions, StartStatusDetection, StopStatusDetection, StartStatusDetectionSuccess } from './../actions/migrate.actions';
import { Injectable } from "@angular/core";
import { ofType, Actions, createEffect } from "@ngrx/effects";
import { switchMap } from "rxjs/operators";
import { of } from "rxjs";
import { BzgToastService } from "bz-genome-angular";
import { TranslateService } from "@ngx-translate/core";
import { Store } from "@ngrx/store";
import { AuthenticationTypeValidationSevice } from "app/shared/services/authentication-type-validation.service";
import { MigrateActions } from "../actions/migrate.actions";
import { MigrateService } from 'app/migrate-stakeholders/core/migrate.service';

@Injectable()
export class MigrateEffects {

  startMigration$ = createEffect(() =>
    this._actions$.pipe(
      ofType<MigrateActions>(EMigrateActions.START_MIGRATION),
      switchMap(async () => {
        await this._migrateService.startSynchronization();
        return new StartStatusDetection();
      })
    )
  );
  cancelMigration$ = createEffect(() =>
    this._actions$.pipe(
      ofType<MigrateActions>(EMigrateActions.CANCEL_MIGRATION),
      switchMap(async () => {
        await this._migrateService.cancelSynchronization();
        return new StopStatusDetection();
      })
    ));
  detectStatusMigration$ = createEffect(() =>
    this._actions$.pipe(
      ofType<MigrateActions>(EMigrateActions.START_STATUS_DETECTION),
      switchMap(() => this._migrateService.getSynchronizationStatus()),
      switchMap((response) => {
        return of(new StartStatusDetectionSuccess(response));
      })
    ));

  constructor(
    private _migrateService: MigrateService,
    private _actions$: Actions) {
  }
}
